import LatestUpdatesResponse from '@Types/api/strapi/LatestUpdatesResponse';
import { getStrapiUrl } from '@Utils/getApiUrl';
import { defineAuthHeaders } from '@Utils/api/defineAuthHeaders';
import { ApiBaseName, ApiReducerPath } from '@Enum/index';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { extractAuthToken } from '@Utils/api/extractAuthToken';

const baseUrl = getStrapiUrl();

const strapiParams = new URLSearchParams();
strapiParams.append('pagination[limit]', '15'); // limit data to 15 news
strapiParams.append('sort[0]', 'createdAt:desc'); // get only latest news
strapiParams.append('populate', '*'); // get records with all information (meta, images and etc...)

const searchQueryParams = decodeURIComponent(strapiParams.toString());

export const strapiApi = createApi({
  tagTypes: ['strapi'],
  reducerPath: ApiReducerPath.API_STRAPI,
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      return defineAuthHeaders({
        headers,
        allowOrigin: false,
        token: extractAuthToken(getState),
      });
    },
  }),
  endpoints: (builder) => ({
    getLatestUpdates: builder.query<LatestUpdatesResponse, void>({
      query: () => ({
        url: `${ApiBaseName.STRAPI}/latest-updates?${searchQueryParams}`,
        method: 'get',
      }),
    }),
    getUploadedImage: builder.query<string, string>({
      queryFn: async (fileName, { getState }) => {
        const token = extractAuthToken(getState);
        const response = await fetch(`${baseUrl}/${fileName}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const imageBlob = await response.blob();
        const imageObjectURL = URL.createObjectURL(imageBlob);

        return {
          data: imageObjectURL,
        };
      },
    }),
  }),
});

export const { useGetLatestUpdatesQuery, useGetUploadedImageQuery } = strapiApi;
